import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'featureFlag',
    standalone: false
})
export class FeatureFlagPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
